import { observable, action, runInAction } from "mobx";

import { ReportApiService } from "@api-services/reports/ReportApiService";
import GamingHistoryStore from "./GamingHistoryStore";

import { GamingActivityReviewReportDto } from "@api-types/reports/ReportResultDto";
import type { RootStore } from "@state/stores/types";
import { logger } from "@utils/logger/logger";

export default class GamingHistoryReportStore {
	rootStore: RootStore;
	gamingHistoryStore: GamingHistoryStore;

	constructor(rootStore: RootStore, gamingHistoryStore: GamingHistoryStore) {
		this.rootStore = rootStore;
		this.gamingHistoryStore = gamingHistoryStore;
	}

	//#region observables

	@observable gamingHistoryReport: GamingActivityReviewReportDto | null =
		null;

	@observable from: string | null = null;
	@observable to: string | null = null;

	//#endregion observables

	//#region actions

	@action.bound
	async fetchReports(filter: { from: string; to: string }) {
		let gamingHistoryReport: any = null;

		if (filter.from > filter.to) {
			logger.logError(
				new Error(
					`DateFrom/StartDate ${filter.from} is larger than DateTo/EndDate ${filter.to}`
				)
			);
		} else {
			gamingHistoryReport = await ReportApiService.getGamingHistoryReport(
				filter.from as string,
				filter.to as string
			);
		}

		runInAction(() => {
			this.from = filter.from;
			this.to = filter.to;
			this.gamingHistoryReport = gamingHistoryReport
				?.result?.[0] as GamingActivityReviewReportDto;
		});
	}

	//#endregion actions
}
